module.exports = "/images/shoppingCart_light_mobile.png";